import { GET_SYSTEM_CONFIG, SET_SYSTEM_CONFIG } from "../actions/ActionTypes";

const initialState = {
    guest_count: 2,
    version_control: {
        android: {
            minimum_version: 0,
            threshold_version: 0,
            message: ""
        },
        ios: {
            minimum_version: 0,
            threshold_version: 0,
            message: ""
        }
    },
    isLoading: true,
};
const initial = false;
function SystemConfigReducer(state = initialState, actions) {
    if (actions.type === GET_SYSTEM_CONFIG) {
        return {
            ...state,
            ...actions.payload,
        };
    }
    if (actions.type === SET_SYSTEM_CONFIG) {
        return {
            ...state,
            ...actions.payload,
        };
    }
    if (
        actions.type === "LOADING" &&
        actions.payload.action_model === GET_SYSTEM_CONFIG
    ) {
        return {
            ...state,
            isLoading: actions.payload.loading,
        };
    }
    return state;
}

export { SystemConfigReducer };
